import React, { useEffect, useState, useRef } from 'react'

export default function GalleryLightbox({ images, startIndex, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(startIndex)
  const touchStartX = useRef(0)
  const touchEndX = useRef(0)

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight') handleNext()
      if (e.key === 'ArrowLeft') handlePrev()
    }
    window.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden' // Prevent background scrolling

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'unset'
    }
  }, [currentIndex])

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length)
  }

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)
  }

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].screenX
  }

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].screenX
    handleSwipe()
  }

  const handleSwipe = () => {
    const swipeThreshold = 50
    const diff = touchStartX.current - touchEndX.current
    if (diff > swipeThreshold) {
      handleNext() // Swiped left
    } else if (diff < -swipeThreshold) {
      handlePrev() // Swiped right
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 backdrop-blur-sm select-none">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer"
        aria-label="Luk galleri"
      >
        <i className="fa-regular fa-xmark text-xl" />
      </button>

      {/* Navigation Buttons */}
      {images.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            className="absolute left-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer md:left-8"
            aria-label="Forrige billede"
          >
            <i className="fa-regular fa-chevron-left text-xl" />
          </button>
          <button
            onClick={handleNext}
            className="absolute right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer md:right-8"
            aria-label="Næste billede"
          >
            <i className="fa-regular fa-chevron-right text-xl" />
          </button>
        </>
      )}

      {/* Main Image Container */}
      <div
        className="relative flex max-h-full max-w-full flex-col items-center justify-center"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={images[currentIndex]}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-h-[85vh] max-w-full rounded-lg object-contain shadow-2xl"
        />

        {/* Counter & Description */}
        <div className="mt-4 text-center text-sm text-gray-400 font-medium">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>
    </div>
  )
}
